<div [class]="mode" [style.backgroundColor]="backgroundColor" [style.height]="height" [style.minHeight]="minHeight">
    <ng-content select=".section-title"></ng-content>
    <ng-content select=".section-content" class="section-content"></ng-content>
</div>
